const { default: axios } = require("axios");
const { debounce } = require("lodash");
import Swal from 'sweetalert2';
const { customEvent } = require("../modules/tracking/AnalyticsEvents");

window.togglePasswordVisibility = function (inputId, eyeIconId) {
    const passwordInput = document.getElementById(inputId);
    const eyeIcon = document.getElementById(eyeIconId);

    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        eyeIcon.src = '/images/my-account/eye-closed.svg';
    } else {
        passwordInput.type = 'password';
        eyeIcon.src = '/images/my-account/eye-open.svg';
    }
}

const myAccountStep = {
    1: document.getElementById('register-step-1'),
    2: document.getElementById('register-step-2'),
    3: document.getElementById('register-step-3'),
};
const myAccountValidator = {
    1: new ContactFormValidator({ element: myAccountStep[1], redesign: true }),
    2: new ContactFormValidator({ element: myAccountStep[2], redesign: true }),
    3: new ContactFormValidator({ element: myAccountStep[3], redesign: true }),
};

const invalidRegModal = document.getElementById('invalid-registration-modal');
const invalidRegModalButton = invalidRegModal.querySelector('.btn--primary');
invalidRegModalButton.addEventListener('click', function() {
    invalidRegModal.style.display = 'none';
});

const registrationInput = document.querySelector('#my-account-register-form #reg_no');
const registrationContainer = document.querySelector('#my-account-register-form #reg_no-container');
const mileageInput = document.querySelector('#my-account-register-form #mileage');
const mileageContainer = document.querySelector('#my-account-register-form #mileage-container');
const noVehicleInput = document.querySelector('#my-account-register-form #no_vehicle');

noVehicleInput.addEventListener('change', function () {
    if (noVehicleInput.checked) {
        mileageContainer.style.display = 'none';
        registrationContainer.style.display = 'none';

        mileageInput.value = '';
        registrationInput.value = '';

        mileageInput.removeAttribute('data-validate');
        registrationInput.removeAttribute('data-validate');
    } else {
        mileageContainer.style.display = 'block';
        registrationContainer.style.display = 'block';

        mileageInput.setAttribute('data-validate', 'input');
        registrationInput.setAttribute('data-validate', 'input');
    }
})

const validateRegistration = debounce(function(regNo) {
    return new Promise((resolve, reject) => {
        if (regNo.length == 0) {
            reject();
            return;
        }

        customEvent('My Account', 'Page loads', 'Creation of Account - Validating Vehicle');
        axios.post('/api/my-account/validate-registration', { reg_no: regNo })
            .then(response => {
                customEvent('My Account', 'Page loads', 'Creation of Account - Valid Vehicle');
                resolve(response.data);
            })
            .catch(error => {
                customEvent('My Account', 'Page loads', 'Creation of Account - Invalid Vehicle');
                console.error('Problem validating registration');
                console.error(error);
                reject();
            });
    })
}, 500, { leading: true, trailing: true });


const myAccountNextStep = async function (step) {
    if (step == 2) {
        customEvent('My Account', 'Page loads', 'Creation of Account - Enter Email');
    }
    if (step == 3) {
        customEvent('My Account', 'Page loads', 'Creation of Account - Enter Personal Details');
    }
    for (let index = 1; index < step; index++) {
        // Index 2 has the vehicle registration and we need to ensure the vehicle is valid
        if (index == 2) {
            if (!await myAccountValidator[index].isValid()) {
                myAccountStep[1].style.display = 'none';
                myAccountStep[2].style.display = 'block';
                myAccountStep[3].style.display = 'none';
                step = 2;
                return;
            }
            const currentRegistrationValue = registrationInput.value;
            myAccountValidator[index].preventInput();
            if(currentRegistrationValue.trim() !== ''){
                validateRegistration(currentRegistrationValue)
                .then(data => {
                    myAccountValidator[index].allowInput();
                    if (data.status == 'invalid') {
                        invalidRegModal.style.display = 'flex';
                        myAccountStep[1].style.display = 'none';
                        myAccountStep[2].style.display = 'block';
                        myAccountStep[3].style.display = 'none';
                        step = 2;
                        return;
                    }

                    myAccountStep[1].style.display = 'none';
                    myAccountStep[2].style.display = 'none';
                    myAccountStep[3].style.display = 'none';
                    myAccountStep[step].style.display = 'block';
                    step = index;
                })
                .catch(error => {
                    myAccountValidator[index].allowInput();
                    invalidRegModal.style.display = 'flex';
                })
            return;
            }else{
                myAccountValidator[index].allowInput();
            }
        }

        if (await myAccountValidator[index].isValid()) {
            continue;
        }

        if (index == 1) {
            customEvent('My Account', 'Page loads', 'Creation of Account - Failed Validation - Email Step');
        } else if (index == 2) {
            customEvent('My Account', 'Page loads', 'Creation of Account - Failed Validation - Personal Details Step');
        } else if (index == 3) {
            customEvent('My Account', 'Page loads', 'Creation of Account - Failed Validation - Password Step');
        }

        step = index;
        break;
    }
    myAccountStep[1].style.display = 'none';
    myAccountStep[2].style.display = 'none';
    myAccountStep[3].style.display = 'none';
    myAccountStep[step].style.display = 'block';
};

window.myAccountNextStep = myAccountNextStep;

document.getElementById('my-account-register-form').addEventListener('submit', async function (event) {
    for (let index = 1; index < 4; index++) {
        if (!await myAccountValidator[index].isValid()) {
            myAccountStep[1].style.display = 'none';
            myAccountStep[2].style.display = 'none';
            myAccountStep[3].style.display = 'none';
            myAccountStep[index].style.display = 'block';
            event.preventDefault();
            return false;
        }
    }
    customEvent('My Account', 'Page loads', 'Creation of Account - Enter Password');
    return true;
})

customEvent('My Account', 'Page loads', 'Creation of Account - Enter Email');



// WEBPACK FOOTER //
// ./resources/assets/js/my-account/register.js